import { createSelector } from 'reselect';

import getAllDocuments from '../layers/getAllDocuments';

const getAllTransforms = createSelector([getAllDocuments], (documents) =>
    documents.map((doc) => doc.transforms).reduce((acc, arr) => acc.concat(arr), []),
);

export default getAllTransforms;
